import { render, staticRenderFns } from "./ChartsColumn.vue?vue&type=template&id=0b96ce2a&scoped=true&"
import script from "./ChartsColumn.vue?vue&type=script&lang=js&"
export * from "./ChartsColumn.vue?vue&type=script&lang=js&"
import style0 from "./ChartsColumn.vue?vue&type=style&index=0&id=0b96ce2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96ce2a",
  null
  
)

export default component.exports